<p-toast></p-toast>
<div class="p-4">
  <div *ngIf="invokedFromChat" class="flex justify-content-between align-items-start mb-3">
    <div>
      <h3 class="text-blue-800 text-xl font-bold mb-1">Promo Plan: {{ businessObjectId }}</h3>
      <p class="text-600 text-sm">{{ businessObjectDescription }}</p>
    </div>
    <!-- Status Tag (optional, could be derived from approvers or passed as input) -->
    <p-tag class="mt-4" value="Pending" severity="warning" [rounded]="true"></p-tag>
  </div>

  <h4 class="text-lg font-semibold">Approval Workflow</h4>
  <div class="flex flex-column approval-timeline-container card p-3 border-round surface-card">
    <ng-container *ngFor="let workflowApproval of workflowApprovals; let i = index">
      <!-- Approver Node -->
      <div class="grid align-items-center timeline-node-vertical">
        <div class="col-4 text-center">
          <p-tag [value]="workflowApproval.workflowStatus?.statusName?.toUpperCase()"
            [severity]="getStatusSeverity(workflowApproval)" [rounded]="true"></p-tag>
        </div>
        <div class="col-1 flex flex-column align-items-center timeline-marker-vertical">
          <img [src]="workflowApproval.approverUser?.profilePictureUrl || 'assets/technical_support.png'"
            alt="{{ workflowApproval.approverUser?.fullName || 'User' }}'s avatar" class="approver-avatar">
          <!-- Vertical Line between nodes -->
          <div *ngIf="i < workflowApprovals.length - 1" class="timeline-connector-vertical" [ngClass]="{
                'bg-green-600': !isLineActive(i) && (workflowApproval.isSuccessAction ?? true), 
                'bg-green-200': isLineActive(i) && (workflowApproval.isSuccessAction ?? true), 
                'bg-red-600': !isLineActive(i) && !(workflowApproval.isSuccessAction ?? true), 
                'bg-red-200': isLineActive(i) && !(workflowApproval.isSuccessAction ?? true), 
                }">
          </div>
        </div>
        <div class="col-4">
          <span class="font-bold">{{ workflowApproval.approverUser?.fullName ?? '' }}</span><br>
          <span class="text-gray-500">{{ workflowApproval.requiredRole?.roleName }}</span>
        </div>
        <div class="col-3">
          <div *ngIf="workflowApproval.actionTaken === 'APPROVED' && workflowApproval.actionDate"
            class="text-sm text-green-600">
            <i class="pi pi-check-circle mr-1"></i> Approved on {{ workflowApproval.actionDate | appDate:'medium'
            }}
          </div>
          <div *ngIf="workflowApproval.actionTaken === 'REJECTED' && workflowApproval.actionDate"
            class="text-sm text-red-600">
            <i class="pi pi-times mr-1"></i> Rejected on {{ workflowApproval.actionDate | appDate:'medium'
            }}
          </div>
          <div *ngIf="workflowApproval.actionTaken === 'PENDING'" class="text-sm text-orange-500">
            <i class="pi pi-clock mr-1"></i> Pending
          </div>
          <div *ngIf="workflowApproval.actionComments" class="text-sm text-gray-500">
            <br><i class="pi pi-comment mr-1"></i> {{ workflowApproval.actionComments }}
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Comments Input -->
  <div class="mt-4">
    <p-floatLabel>
      <textarea id="actionComments" pInputTextarea [(ngModel)]="actionComments" rows="3" class="w-full"></textarea>
      <label for="actionComments">Comments (Optional)</label>
    </p-floatLabel>
  </div>

  <!-- Moved buttons to a footer for better layout -->
  <div class="flex justify-content-end gap-2 mt-4 pt-3 border-top-1 surface-border">
    <p-button *ngIf="invokedFromChat" label="Open Details" icon="pi pi-external-link" severity="secondary" (onClick)="onOpenDetails()"></p-button>
    
    <!-- Action Buttons -->
    <p-splitbutton *ngIf="rejectedWorkflowApprovals.length > 1" label="Reject" icon="pi pi-times" severity="danger" [model]="failedStatuses" />
    <p-button *ngIf="rejectedWorkflowApprovals.length === 1" label="Reject" icon="pi pi-times" severity="danger" (onClick)="onActionTaken(rejectedWorkflowApprovals[0], 'REJECTED')" [loading]="isProcessing"></p-button>
    
    <p-splitbutton *ngIf="successWorkflowApprovals.length > 1" label="Approve" icon="pi pi-check" severity="success" [model]="successStatuses" />
    <p-button *ngIf="successWorkflowApprovals.length === 1" label="Approve" icon="pi pi-check" severity="success" (onClick)="onActionTaken(successWorkflowApprovals[0], 'APPROVED')" [loading]="isProcessing"></p-button>
  </div>
</div>